<cb-dialog
    class="flex-col"
    [dialogHeading]="isEdit() ? 'Edit Trade Type' : 'Add Trade Type'"
    (cancelDialog)="cancel()"
>
    <form #tradeTypeEditForm="ngForm">
        <cb-input
            label="Trade Type"
            type="text"
            name="tradeType"
            [(ngModel)]="mappedItem.label"
            [readonly]="isView()"
            [required]="true"
            [maxlength]="100"
        ></cb-input>
        @if (mappedItem?.mappedChildren?.length < 1) {
            <cb-select
                label="Parent"
                name="parentSelect"
                [(ngModel)]="mappedItem.parentId"
                [readonly]="isView()"
                [options]="availableTradeTypes"
            ></cb-select>
        }
    </form>
    <form #tradeTypeTableForm="ngForm">
        @if (mappedItem.parentId) {
            <cb-table
                class="cb-margin-top"
                label="Compliance Registrations"
                [stringColumns]="columns"
                [loaded]="loaded"
            >
                <tbody cbTableBody>
                    @for (compReg of mappedItem.requiredComplianceRegistrations; track compReg) {
                        <tr>
                            <td>
                                {{ compReg.label }}
                            </td>
                            <td>
                                <button mat-icon-button (click)="removeCompReg(compReg.id)">
                                    <mat-icon> remove_circle </mat-icon>
                                </button>
                            </td>
                        </tr>
                    }
                    <tr>
                        <td>
                            <cb-autocomplete-scroller
                                class="flex"
                                *cbWaitFor="!autocompleteLoading"
                                label="Compliance Registration"
                                name="selectComplianceReg"
                                [(ngModel)]="selectedCompReg"
                                [requireMatch]="true"
                                [matchProps]="['id']"
                                [querySearch]="querySearch"
                            ></cb-autocomplete-scroller>
                        </td>
                        <td>
                            <button
                                mat-icon-button
                                (click)="addCompReg()"
                                [disabled]="disableAddCompReg()"
                            >
                                <mat-icon> add </mat-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </cb-table>
        }
    </form>
    <form #tradeTypeEditForm2="ngForm" class="cb-checkbox-list flex-col">
        @if (mappedItem.parentId) {
            <cb-checkbox
                label="Include In Live Schedule"
                name="includeInLiveSchedule"
                [(ngModel)]="mappedItem.includeInLiveSchedule"
            ></cb-checkbox>
        }
        @if (mappedItem.parentId) {
            <cb-checkbox
                label="Can Request 7 Day Payments"
                name="canRequestSevenDayPayments"
                [(ngModel)]="mappedItem.canRequestSevenDayPayments"
            ></cb-checkbox>
        }
        @if (!activeChildren || isAdd()) {
            <cb-checkbox
                label="Active"
                name="isActive"
                [(ngModel)]="mappedItem.isActive"
            ></cb-checkbox>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="
                !(
                    tradeTypeEditForm.valid &&
                    tradeTypeEditForm2.valid &&
                    (complianceRegsChanged || tradeTypeEditForm.dirty || tradeTypeEditForm2.dirty)
                )
            "
            (cbClick)="save()"
        >
            {{ isEdit() ? 'Save' : 'Add' }}
        </button>
        <button mat-raised-button (cbClick)="cancel()">Cancel</button>
    </div>
</cb-dialog>
